export default {
  downtimeUrl: "https://tr2.kodland.tech",
  startPage: {
    image: "/welcome/quiz_scratch_boy.jpeg",
    title:
      "<div>İki dakikalık anketi doldurarak ÜCRETSİZ bir programlama dersine davetiye alın</div>",
    button: "Haydi başlayalım!  🚀",
  },
  successPage: {
    title: "Ücretsiz dersinizi almak için tarih belirleyin",
    subtitle: "📆 Hemen Kaydol butonuna tıklayarak rezervasyonu tamamlayabilirsiniz.",
    button: "📆 Hemen Kaydol",
  },
  quizRotateBySteps: {
    1: {
      question:
        "Çocuğunuzun bilgisayar başında geçirdiği zamanın daha verimli bir hâle gelmesini ister misiniz?",
      answers: ["🙂 Evet", "🙌 Hayır"],
    },
    2: {
      question: "Sizce çocuğunuzun ilgi alanları nelerdir?",
      answers: [
        "🎨 Web tasarımı",
        "🎮 Oyun geliştirme",
        "🖼 Grafik tasarımı",
        "🤖 Roblox",
        "👍 Diğer",
      ],
    },
    3: {
      question: "Ücretsiz dersinizden kazanmak istediğiniz en önemli şeyler nelerdir?",
      answers: [
        "😌 Çocuğunuzla daha iyi bir iletişim/bağ",
        "💻 Geleceğe yönelik yararlı beceriler",
        "👍 Samimi ve keyifli bir deneyim",
        "🎓 Çocuğunuzun motivasyonunda bir artış",
        "😎 Kullanıcı dostu öğrenme platformumuz hakkında bilgi",
      ],
    },
    4: {
      question: "Çocuğunuzun okulda en sevdiği ders hangisidir?",
      answers: [
        "🔬 Fen bilimleri",
        "🎨 Sanat ve tasarım",
        "💻 Bilgisayar bilimi",
        "📙 Tarih, Edebiyat",
        "🗣 Yabancı diller",
        "➗ Matematik",
        "❤️ Tüm dersler",
        "🤔 Emin değilim",
      ],
    },
    5: {
      question: "Çocuğunuzun herhangi bir bilgisayar becerisi var mı?",
      answers: [
        "👍 Evet, oyun oynamayı sever (Roblox, Minecraft)",
        "💬 Evet, Microsoft Word/PowerPoint",
        "💻 Evet, temel kodlama",
        "🤔 Hayır",
      ],
    },
    6: {
      question: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
      answers: ["💻 Evet", "🙁 Hayır"],
    },
  },
};
